export * from './gutachten-entfernt.interface';
